import { render, staticRenderFns } from "./legal-modal.vue?vue&type=template&id=3ad0b61b"
import script from "./legal-modal.vue?vue&type=script&lang=js"
export * from "./legal-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports